export default __webpack_public_path__ + "static/media/grocery.ef6fb5a8.svg";